// extracted by mini-css-extract-plugin
module.exports = {"contenedorSalud":"SaludContainer_contenedorSalud__CfZml"};